// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_2fd","cls2":"RelatedWorksCard-cls2_xaw RelatedWorksCard-cls1_2fd","altLook":"RelatedWorksCard-altLook_sr8"};